import React, { useState } from 'react';
import '../App.css';
import WaitlistModal from '../components/WaitlistModal';

const Home = () => {
    const [isWaitlistModalOpen, setIsWaitlistModalOpen] = useState(false);

    return (
        <>
            <main className="App-main">
                {/* Hero Section */}
                <section className="hero-section">
                    <div className="hero-content">
                        <h2 className="hero-title">Connect Buyers & Suppliers</h2>
                        <p className="hero-subtitle">
                            List products you have or search for products you need. Get matched with the perfect partners.
                        </p>
                        <div className="hero-actions">
                            <button className="btn-primary" onClick={() => setIsWaitlistModalOpen(true)}>Join the Waitlist</button>
                        </div>
                    </div>
                </section>

                {/* Features Section */}
                <section className="features-section">
                    <h3 className="section-title">How It Works</h3>
                    <div className="features-grid">
                        <div className="feature-card">
                            <div className="feature-icon">📦</div>
                            <h4>List Products</h4>
                            <p>Suppliers can easily list their products with detailed descriptions and specifications.</p>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon">🔍</div>
                            <h4>Search & Discover</h4>
                            <p>Buyers can search for products they need and discover new suppliers in their industry.</p>
                        </div>
                        <div className="feature-card">
                            <div className="feature-icon">🤝</div>
                            <h4>Get Matched</h4>
                            <p>Our intelligent matching system connects buyers and suppliers based on their needs.</p>
                        </div>
                    </div>
                </section>

                {/* CTA Section */}
                <section className="cta-section">
                    <div className="cta-content">
                        <h3>Be Among the First</h3>
                        <p>Join our waitlist to get early access when we launch. Connect with buyers and suppliers in your industry.</p>
                        <div className="cta-buttons">
                            <button className="btn-primary" onClick={() => setIsWaitlistModalOpen(true)}>Join the Waitlist</button>
                        </div>
                    </div>
                </section>
            </main>
            <WaitlistModal isOpen={isWaitlistModalOpen} onClose={() => setIsWaitlistModalOpen(false)} />
        </>
    );
};

export default Home;

